import { useState } from 'react'
import { Check, Copy } from 'lucide-react'

/** First 8 characters of an id with a copy button; the full id is in title and aria-label. */
export default function ShortId({ value }: { value?: string | null }) {
  const [copied, setCopied] = useState(false)
  if (!value) return <span className="text-muted-foreground" aria-label="empty">—</span>
  async function copy() {
    try {
      await navigator.clipboard.writeText(value!)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      // clipboard blocked (e.g. insecure context): nothing useful to do
    }
  }
  return (
    <span className="inline-flex items-center gap-1 font-mono" title={value}>
      {value.slice(0, 8)}
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation()
          void copy()
        }}
        aria-label={`Copy ${value}`}
        className="-my-1 inline-flex size-6 items-center justify-center rounded text-muted-foreground hover:bg-muted hover:text-foreground focus-visible:outline-2 focus-visible:outline-ring max-sm:size-11"
      >
        {copied ? <Check className="size-3" /> : <Copy className="size-3" />}
      </button>
    </span>
  )
}
